<p-dialog [(visible)]="dialogService.visible" [modal]="true" [style]="{width: '350px'}" [closable]="false"
    [draggable]="false" header="{{ dialogService.header }}">
    <p class="message-text">{{ dialogService.message }}</p>

    <div style="text-align:right; margin-top: 1rem;">
        <button pButton label="OK" class="p-button-primary" (click)="dialogService.hide()">
        </button>
    </div>
</p-dialog>